import React, { FunctionComponent } from "react";
import HiringHubHeader from "../shared/general/HiringHubHeader";
import FormComponent from "./FormComponent";
import Theme from "../../theme/theme";
import { Wrapper, Container } from "./styles/diversity-form-styles";

export const DiversityForm: FunctionComponent<unknown> = () => (
  <Theme>
    <HiringHubHeader color="purple" otb />
    <Wrapper>
      <Container>
        <FormComponent />
      </Container>
    </Wrapper>
  </Theme>
);

export default DiversityForm;
